<template>
  <div ref="categoriesEl" class="categories">
    <template v-for="category in module.config.general.categories">
      <a
        v-if="category.isEnabled"
        :key="category.id"
        class="category"
        :style="categoriesElStyles"
        :href="category.url"
        @click="$emit('emittedClick', category)"
      >
        <div class="title">
          <span>{{ category.title }}</span>
          <span v-if="module.config.general.showJobCounter" class="job-count">
            {{ getJobCountForCategory(category.title) }}
          </span>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import categoriesModule from "../categoriesDefaultModuleProp.js";
import { categoriesComputed } from "../mixins/categories.js";

export default {
  name: "CategoriesRibbon",
  mixins: [categoriesComputed],
  props: {
    module: {
      type: Object,
      default() {
        return categoriesModule;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/shared.scss";

.categories {
  align-content: center;
  flex-wrap: wrap;
  column-gap: 25px;
}

.category {
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 10px;

  border-bottom: 2px dotted transparent;

  &:hover {
    border-bottom: 2px dotted var(--categories-border-color);
  }

  .job-count {
    align-self: flex-start;
    position: relative;
    bottom: 2ex;

    @include mobile {
      bottom: initial;
      padding-inline-start: 5px;
    }
  }
}
</style>
